<template lang="pug">
  .top5Walkers
    WtTitle(card-title) {{ title }}
    .subtitle.is-size-6(v-if="subTitle") {{ subTitle }}

    div(v-if="data")
      .card(v-for="member in data" :key="member.id").mb-2
        .card-content.p-1
          .is-flex.is-justify-content-space-between.is-align-items-center.px-2
            .avatar-and-username.is-flex
                .entity-avatar-container.pr-2
                  EntityAvatar(
                    :image="member.avatar"
                    is-rounded=true
                    size-class="is-32x32"
                  )
                .username-container.is-flex.is-align-items-center
                  div(v-if="member.name")
                    WtRouterLink(
                      to="ProfilePage"
                      :params="{ username: member.profileName }"
                      :text="member.name"
                    ).custom-router-link
                  div(v-if="member.teamName")
                    WtRouterLink(
                      to="Team"
                      :params="{ teamId: member.id }"
                      :text="member.teamName"
                    ).custom-router-link
            .steps-data.has-text-right
              .is-flex(v-if="leaderboardTracking === 'steps&activities' && _.has(member, 'totalSteps') && _.has(member, 'totalActivities')")
                .is-flex.is-flex-direction-column
                  span.is-size-7.has-text-weight-light Steps & Activities
                  span.is-size-5.has-text-weight-bold {{ formatWithCommas(member.totalSteps + member.totalActivities) }}
              //- TODO ? align so it's either steps or totalSteps
              .is-flex(v-if="leaderboardTracking === 'steps' && (member.tally >= 0)")
                .is-flex.is-flex-direction-column
                  span.is-size-7.has-text-weight-light {{ leaderboardTrackingText }}
                  span.is-size-5.has-text-weight-bold {{ formatWithCommas(member.tally) }}
              .is-flex(v-if="leaderboardTracking === 'points' && (member.tally >= 0)")
                .is-flex.is-flex-direction-column
                  span.is-size-7.has-text-weight-light Points
                  span.is-size-5.has-text-weight-bold {{ formatWithCommas(member.tally) }}

</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";
import HorizontalBarChart from "@/charts/HorizontalBarChart";
import EntityAvatar from "@@/WtEntityAvatar/WtEntityAvatar";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import { numberUtilityMixin } from "@/mixins/numberUtilityMixin";

export default {
  name: "Top5Walkers",
  components: {
    WtTitle,
    HorizontalBarChart,
    WtTile,
    EntityAvatar,
    WtRouterLink
  },
  mixins: [numberUtilityMixin],
  props: {
    title: {
      type: String,
      required: true
    },

    subTitle: {
      type: String,
      default: null
    },

    data: {
      type: [Array, Object],
      required: true
    },

    leaderboardTracking: {
      type: String,
      default: "steps"
    },

    leaderboardTrackingText: {
      type: String,
      default: "steps"
    }
  },

  data() {
    return {
      backgroundColor: ""
    };
  }
};
</script>

<style lang="sass" scoped>
.no-padding
  padding: 0px

small
  color: $grey
  font-size: 12px

.card
  background-color: $grey-lighter
.entity-avatar-container
  /deep/ img
    height: 100%
.custom-router-link
  text-decoration: none
  color: $black
  font-
  &:hover
    color: $grey
</style>
